export default "__VITE_ASSET__BTAua9uK__"